
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import CustomerStateHandler from '@customer/components/CustomerStateHandler.vue';

interface Props {
  article: ArticleData;
  size: String;
}

interface Computed {
  isPressPelease: boolean;
  isPtContent: boolean;
}

interface Methods {
  scrollToPaywall: () => void;
}

export default Vue.extend<unknown, unknown, Computed, Props, Methods>({
  components: {
    CustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
  },
  computed: {
    isPressPelease() {
      const settings: any = this.article.settings;
      return !!settings['icon.press_release'] || !!settings['frontPagePressRelease'];
    },
    isPtContent() {
      const settings: any = this.article.settings;
      return !!settings['icon.reklama'] || !!settings['frontPageSponsoredContent'];
    },
  },
  methods: {
    scrollToPaywall() {
      const paywall = document.querySelector(`#article-${this.article.id} .article-paywall`) as HTMLElement;
      paywall.scrollIntoView({ behavior: 'smooth' });
    },
  },
});
